import { Component, ChangeDetectionStrategy } from '@angular/core';
import { APP_VERSION_LABEL } from '../../../config/app-version';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  readonly versionLabel = APP_VERSION_LABEL;
}
